<template>
	<div>page not found...</div>
</template>
<script>
	export default{
		name:'404',
		data(){
			return{

			}
		}
	}
</script>
<style>
	
</style>